/**
 * Conditional Auth0Provider.
 *
 * When AUTH_ENABLED=false: renders children directly (no Auth0 SDK loaded)
 * When AUTH_ENABLED=true: lazy-loads Auth0Wrapper (code-split)
 */
import { Suspense, lazy } from 'react'
import { AUTH_ENABLED } from './config'

const Auth0Wrapper = lazy(() => import('./Auth0Wrapper'))

interface Props {
  children: React.ReactNode
}

export default function AuthProvider({ children }: Props) {
  if (!AUTH_ENABLED) {
    return <>{children}</>
  }

  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-screen bg-background">
          <div className="text-muted-foreground">Loading auth...</div>
        </div>
      }
    >
      <Auth0Wrapper>{children}</Auth0Wrapper>
    </Suspense>
  )
}
